<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{ hitType: string; count?: number }>();

const categories: Record<string, { label: string; style: string }> = {
  sanctions: { label: 'SANCTION', style: 'bg-red-50 text-red-700' },
  pep: { label: 'PEP', style: 'bg-indigo-50 text-violet-700' },
  adversemedia: { label: 'ADVERSE MEDIA', style: 'bg-amber-50 text-amber-700' },
  watchlist: { label: 'WATCHLIST', style: 'bg-indigo-50 text-sky-700' },
  rca: { label: 'RCA', style: 'bg-gray-100 text-gray-500' },
  crime: { label: 'CRIME', style: 'bg-red-50 text-red-700' },
  terrorism: { label: 'TERRORISM', style: 'bg-red-50 text-red-700' },
  fitnessprobity: { label: 'FITNESS & PROBITY', style: 'bg-blue-50 text-blue-700' },
};

const category = computed(
  () =>
    categories[props.hitType.toLowerCase()] ?? {
      label: props.hitType,
      style: 'bg-gray-100 text-gray-700',
    }
);
</script>

<template>
  <span
    class="inline-flex w-fit items-center rounded-full px-2 py-0.5 text-[10px] font-semibold tracking-wide"
    :class="category.style"
  >
    {{ count ? `${category.label} ${count}` : category.label }}
  </span>
</template>
